import script from "./ProductsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsBlock.vue?vue&type=script&setup=true&lang=js"

import "./ProductsBlock.vue?vue&type=style&index=0&id=6e0831e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e0831e7"]])

export default __exports__